
import React from 'react';
import {useSelector} from 'react-redux';
import ForecastMain from './ForecastMain';
// import Approve from './Approve';
// import { Badge } from 'react-bootstrap';
// import Translate from '../../components/Translate';

const ForecastTable = ()=>{
    
    const {toList} = useSelector(state=>state.forecast);
    console.log('toList',toList);

    const [showApprove,setShowApprove] = React.useState(false);

    const handleShow = ()=>{
         setShowApprove(!showApprove);
    }

    return (
        <>
        
            <ForecastMain handleShow = {handleShow}  />
               
             
             
        
        </>
    );
};

export default ForecastTable;